import React, { useState, useEffect } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";

const API_KEY = "AIzaSyDVg6LMYhf0bN2Jzzb7tWFWYItEz67x5MM";
const BASE_URL = "https://www.googleapis.com/youtube/v3/search";

const categories = ["Latest", "Pop", "Hip-Hop", "Chill"];

const MiniVideoMusicPlayer = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [songs, setSongs] = useState([]);
  const [currentVideoId, setCurrentVideoId] = useState(null);

  useEffect(() => {
    fetchMusic("Latest Songs");
  }, []);

  const fetchMusic = async (query) => {
    try {
      const response = await axios.get(BASE_URL, {
        params: {
          key: API_KEY,
          part: "snippet",
          q: query + " music",
          type: "video",
          maxResults: 10,
        },
      });

      const songList = response.data.items.map((video) => ({
        id: video.id.videoId,
        title: video.snippet.title,
        artist: video.snippet.channelTitle,
        albumCover: video.snippet.thumbnails.high.url,
      }));

      setSongs(songList);
    } catch (error) {
      console.error("Error fetching music", error);
    }
  };

  // Animation variants for song cards
  const songCardVariants = {
    hidden: { opacity: 0, y: 50, rotate: 5, scale: 0.9 },
    visible: { opacity: 1, y: 0, rotate: 0, scale: 1, transition: { duration: 0.6, ease: "easeOut" } },
    hover: { scale: 1.1, rotate: -2, boxShadow: "0 10px 30px rgba(255, 105, 180, 0.3)", transition: { duration: 0.4 } },
    tap: { scale: 0.95, rotate: 2, transition: { duration: 0.2 } },
  };

  // Animation variants for the mini-player
  const miniPlayerVariants = {
    hidden: { x: 400, opacity: 0, scale: 0.8 },
    visible: {
      x: 0,
      opacity: 1,
      scale: 1,
      transition: { type: "spring", stiffness: 120, damping: 15, duration: 0.8 },
    },
    exit: { x: 400, opacity: 0, scale: 0.8, transition: { duration: 0.5 } },
  };

  // Animation variants for buttons with ripple, glow, and bounce
  const buttonVariants = {
    initial: { scale: 1 },
    hover: {
      scale: 1.2,
      rotate: 5,
      boxShadow: "0 0 15px rgba(255, 105, 180, 0.5)",
      transition: { duration: 0.3, repeat: Infinity, repeatType: "reverse" },
    },
    tap: {
      scale: 0.9,
      rotate: -5,
      transition: { duration: 0.2 },
      boxShadow: "0 0 20px rgba(255, 105, 180, 0.8)",
    },
  };

  // Animation variants for search bar
  const searchBarVariants = {
    initial: { scale: 0.95 },
    animate: { scale: 1, transition: { duration: 0.3 } },
    focus: {
      scale: 1.03,
      boxShadow: "0 0 15px rgba(255, 105, 180, 0.4)",
      transition: { duration: 0.5, repeat: Infinity, repeatType: "reverse" },
    },
  };

  // Animation for category buttons
  const categoryButtonVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.4 } },
    hover: {
      scale: 1.15,
      boxShadow: "0 0 10px rgba(255, 105, 180, 0.3)",
      transition: { duration: 0.3, repeat: Infinity, repeatType: "reverse" },
    },
    tap: { scale: 0.9, transition: { duration: 0.2 } },
  };

  // Animation for close button with spin effect
  const closeButtonVariants = {
    initial: { scale: 1 },
    hover: {
      scale: 1.2,
      rotate: 90,
      boxShadow: "0 0 15px rgba(255, 105, 180, 0.5)",
      transition: { duration: 0.3 },
    },
    tap: { scale: 0.9, rotate: -90, transition: { duration: 0.2 } },
  };

  return (
    <div style={{
      background: "linear-gradient(to bottom, #1A0B2E, #3B1A5A)",
      color: "#FFFFFF",
      minHeight: "100vh",
      fontFamily: "'Circular', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      padding: "20px",
    }}>
      <motion.div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          padding: "20px",
          
          borderRadius: "8px",
        }}
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <motion.img
          src="https://pub-f76b87a889044eea986677ba77f1ce3e.r2.dev/istockphoto-1076582642-612x612.svg"
          alt="Music Player"
          style={{ width: 70, height: "auto" }}
          animate={{ rotate: [0, 15, -15, 0], scale: [1, 1.1, 1] }}
          transition={{ duration: 2, repeat: Infinity, repeatType: "loop" }}
        />
        <span
            style={{
                   fontSize: "28px",
                   fontWeight: "700",
                   color: "black", // A bright turquoise for a fresh, attractive look
                   animation: "pulse 1.5s infinite",
                   display: "inline-block",
                  }}
             >
             BASE ON
            </span>
            

      </motion.div>

      <div style={{
        display: "flex",
        justifyContent: "center",
        padding: "20px",
        gap: "12px",
        flexWrap: "wrap",
      }}>
        <motion.input
          type="text"
          placeholder="Search for songs..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && fetchMusic(searchQuery)}
          style={{
            flex: 1,
            maxWidth: "600px",
            padding: "14px",
            fontSize: "16px",
            borderRadius: "500px",
            border: "none",
            backgroundColor: "#2A1A4A",
            color: "#FFFFFF",
            outline: "none",
            transition: "background-color 0.3s",
          }}
          variants={searchBarVariants}
          initial="initial"
          animate="animate"
          whileFocus="focus"
        />
        <motion.button
          onClick={() => fetchMusic(searchQuery)}
          style={{
            padding: "12px 24px",
            borderRadius: "500px",
            border: "none",
            backgroundColor: "#FF69B4",
            color: "#FFFFFF",
            cursor: "pointer",
            fontSize: "16px",
            fontWeight: "700",
            transition: "background-color 0.3s",
            position: "relative",
            overflow: "hidden",
          }}
          variants={buttonVariants}
          initial="initial"
          whileHover="hover"
          whileTap="tap"
        >
          🔍 Search
          <motion.div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "radial-gradient(circle, rgba(255, 105, 180, 0.5) 0%, transparent 70%)",
              opacity: 0,
            }}
            animate={{ opacity: [0, 1, 0], scale: [0, 2, 3] }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            key={Date.now()} // Trigger animation on each click
          />
        </motion.button>
      </div>

      <motion.div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "12px",
          flexWrap: "wrap",
          marginBottom: "24px",
        }}
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 0 },
          visible: {
            opacity: 1,
            transition: { staggerChildren: 0.2, delayChildren: 0.3 },
          },
        }}
      >
        {categories.map((category) => (
          <motion.button
            key={category}
            style={{
              padding: "8px 16px",
              borderRadius: "16px",
              border: "none",
              backgroundColor: "#2A1A4A",
              color: "#FFFFFF",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "600",
              transition: "background-color 0.3s",
              position: "relative",
              overflow: "hidden",
            }}
            onClick={() => fetchMusic(category)}
            variants={categoryButtonVariants}
            initial="hidden"
            animate="visible"
            whileHover="hover"
            whileTap="tap"
          >
            {category}
            <motion.div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "radial-gradient(circle, rgba(255, 105, 180, 0.3) 0%, transparent 70%)",
                opacity: 0,
              }}
              animate={{ opacity: [0, 1, 0], scale: [0, 2, 3] }}
              transition={{ duration: 0.5, ease: "easeOut" }}
              key={Date.now()} // Trigger animation on each click
            />
          </motion.button>
        ))}
      </motion.div>

      <motion.div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
          gap: "24px",
          padding: "20px",
        }}
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 0 },
          visible: {
            opacity: 1,
            transition: { staggerChildren: 0.15, delayChildren: 0.2 },
          },
        }}
      >
        {songs.map((song) => (
          <motion.div
            key={song.id}
            style={{
              backgroundColor: "#2A1A4A",
              borderRadius: "18px",
              overflow: "hidden",
              cursor: "pointer",
            }}
            variants={songCardVariants}
            initial="hidden"
            animate="visible"
            whileHover="hover"
            whileTap="tap"
          >
            <img
              src={song.albumCover}
              alt={song.title}
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                borderRadius: "8px 8px 0 0",
              }}
            />
            <div style={{ padding: "12px", textAlign: "left" }}>
              <h3 style={{
                fontSize: "10px",
                fontWeight: "600",
                marginBottom: "6px",
                color: "#FFFFFF",
              }}>
                {song.title}
              </h3>
              <p style={{ fontSize: "14px", color: "#B3B3B3" }}>{song.artist}</p>
            </div>
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0 12px 12px",
            }}>
              <motion.button
                style={{
                  backgroundColor: "#FF69B4",
                  border: "none",
                  borderRadius: "67px",
                  padding: "10px 110px",
                  color: "#FFFFFF",
                  cursor: "pointer",
                  fontSize: "16px",
                  transition: "background-color 0.3s",
                  position: "relative",
                  overflow: "hidden",
                }}
                onClick={() => setCurrentVideoId(song.id)}
                variants={buttonVariants}
                initial="initial"
                whileHover="hover"
                whileTap="tap"
              >
                ▶
                <motion.div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "radial-gradient(circle, rgba(255, 105, 180, 0.5) 0%, transparent 70%)",
                    opacity: 0,
                  }}
                  animate={{ opacity: [0, 1, 0], scale: [0, 2, 3] }}
                  transition={{ duration: 0.5, ease: "easeOut" }}
                  key={Date.now()} // Trigger animation on each click
                />
              </motion.button>
            </div>
          </motion.div>
        ))}
      </motion.div>

      <AnimatePresence>
        {currentVideoId && (
          <motion.div
            style={{
              position: "fixed",
              bottom: "20px",
              right: "20px",
              backgroundColor: "#2A1A4A",
              padding: "12px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              borderRadius: "8px",
              zIndex: 999,
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
            }}
            variants={miniPlayerVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <iframe
              width="220"
              height="140"
              src={`https://www.youtube.com/embed/${currentVideoId}?autoplay=1`}
              title="Mini Video Player"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              style={{ borderRadius: "8px", border: "none" }}
            />
            <motion.button
              onClick={() => setCurrentVideoId(null)}
              style={{
                backgroundColor: "#535353",
                border: "none",
                padding: "8px 12px",
                borderRadius: "4px",
                color: "#FFFFFF",
                fontSize: "16px",
                cursor: "pointer",
                transition: "background-color 0.3s",
                position: "relative",
                overflow: "hidden",
              }}
              variants={closeButtonVariants}
              initial="initial"
              whileHover="hover"
              whileTap="tap"
            >
              ✖
              <motion.div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "radial-gradient(circle, rgba(255, 105, 180, 0.5) 0%, transparent 70%)",
                  opacity: 0,
                }}
                animate={{ opacity: [0, 1, 0], scale: [0, 2, 3] }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                key={Date.now()} // Trigger animation on each click
              />
            </motion.button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default MiniVideoMusicPlayer;